import { Column, Table, flexRender } from '@tanstack/react-table';

export interface VisibilityColumnInfo {
  id: string;
  label?: string;
}

export interface LayoutTableVisibilityProps {
  table: Table<any>;
  columns?: VisibilityColumnInfo[];
}

const LayoutTableVisibility: React.FunctionComponent<LayoutTableVisibilityProps> =
  function ({ table, columns }) {
    if (!columns) return null;
    const validIds = columns.map((col: VisibilityColumnInfo) => col.id);
    const leafColumns = table.getAllLeafColumns();
    const validColumns = leafColumns.filter((column: Column<any, unknown>) =>
      validIds.includes(column.id),
    );
    if (validColumns.length === 0) return null;
    return (
      <div className="flex flex-col p-2 border border-neutral-300 rounded-lg mb-3">
        {validColumns.map((column: Column<any, unknown>) => {
          const id = column.id;
          const label =
            columns.filter((col: VisibilityColumnInfo) => col.id === id)?.[0]
              ?.label || column.id;
          return (
            <div key={id}>
              <label>
                <input
                  {...{
                    type: 'checkbox',
                    checked: column.getIsVisible(),
                    onChange: column.getToggleVisibilityHandler(),
                  }}
                  className="appearance-auto"
                />{' '}
                {label}
              </label>
            </div>
          );
        })}
      </div>
    );
  };

export default LayoutTableVisibility;
